import RandingStyle23 from "../../randing/RandingStyle23";

function Randing283({ urlCode, urlCodeSettingId, apiUrl }) {
  return (
    <RandingStyle23
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      totalStep="2"
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/283/01.jpg`}
      img2Path={`${process.env.REACT_APP_CDN_BASE}/images/283/02.jpg`} // 스텝 변경되는 이미지
      formFieldColor="white"
      passBTN={`${process.env.REACT_APP_CDN_BASE}/images/283/nextBtn.png`}
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/postBtns/blue/applyButton_small2.png`}
      companyName="본원"
      // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/ggul.jpg`}
    />
  );
}

export default Randing283;
